// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2Iy2X","info":"PatientInfo_info__322B3"};